export const useVideoContent = () => ({
  trademarkRegistration: {
    url: 'https://www.youtube.com/embed/VYwMtmSBxEo?si=Nbmyp6Ngncu4BUVH',
    thumbnail: {
      src: '/images/video/trademark-registration-thumbnail.png',
      alt: 'Play video',
    },
    background: {
      src: '/images/video/trademark-registration-background.svg',
      alt: 'Abstract background with subtle shapes and video preview',
    },
  },
  brandProtection: {
    url: 'https://www.youtube.com/embed/SVFvciYkXcE?si=VFOIWvbn6Rnmm7aj',
    thumbnail: {
      src: '/images/video/brand-protection-thumbnail.png',
      alt: 'Play video',
    },
  },
  playButton: {
    src: '/images/video/play-button.svg',
    alt: 'Play button',
  },
})
